import { Exclude } from 'class-transformer';

export class AccAttachmentRawDto {
    fileName: string;
    action: string;
    fileBase64String: string;
    fileId: number;
    emailCacheId: number;

    // Transient variable
    @Exclude()
    id?: number;
    @Exclude()
    downloadUrl?: string;
    @Exclude()
    accItemId?: number;
}
